import React from "react";

const Header = () => {
  return (
    <header className="bg-white py-4 px-6 shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <div className="bg-red-600 p-2 rounded-lg mr-3">
            <div className="w-8 h-8 bg-white rounded flex items-center justify-center">
              <span className="text-red-600 font-bold text-lg">AV</span>
            </div>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">A VIDA DE</h1>
            <h2 className="text-2xl font-bold text-gray-900">JESUS</h2>
            <span className="text-sm text-gray-600">O Evangelho da Prosperidade Eterna</span>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <div className="text-sm text-gray-600">
            <span className="block">📍 Disponível em</span>
            <span className="block">📚 Formato físico e digital</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;